import MovieTrailers from './MovieTrailers';

export default MovieTrailers;
